import { ProfessionalSport } from "@app/shared/models";
import * as ProfessionalSportActions from "@app/shared/store/actions/professional-sport.actions";
import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { Action, createReducer, on } from "@ngrx/store";

export const ProfessionalSportFeatureKey = "professional-sport";

export interface State extends EntityState<ProfessionalSport> {
  isLoading: boolean;
}

export const adapter: EntityAdapter<ProfessionalSport> =
  createEntityAdapter<ProfessionalSport>({
    selectId: (ProfessionalSport: ProfessionalSport) => ProfessionalSport.id,
  });

export const initialState: State = adapter.getInitialState({
  isLoading: false,
});

export const ProfessionalSportReducer = createReducer(
  initialState,

  on(ProfessionalSportActions.loadProfessionalSportList, (state) => ({
    ...state,
    isLoading: true,
  })),

  on(
    ProfessionalSportActions.loadProfessionalSportListSuccess,
    (state, { ProfessionalSportList }) =>
      adapter.setAll(ProfessionalSportList, {
        ...state,
        isLoading: false,
      }),
  ),

  on(ProfessionalSportActions.loadProfessionalSportListFailure, (state) => ({
    ...state,
    isLoading: false,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return ProfessionalSportReducer(state, action);
}

export const {
  selectAll: selectProfessionalSportList,
  selectEntities: selectProfessionalSportEntities,
} = adapter.getSelectors();

export const selectIsLoading = (state: State) => state.isLoading;
